import { get, readable, writable } from "svelte/store";
import "./ReadableStore";
import "./WritableStore";
export class Answer {
    constructor(id, instanceId, questionId, value) {
        this.id = id;
        this.instanceId = instanceId;
        this.questionId = questionId;
        this.valueWritable = writable('');
        this.valueReadable = readable('', set => this.valueWritable.subscribe(set));
        this.value = value;
    }
    static fromPrimitives({ id, instanceId, questionId, value }) {
        return new Answer(id, instanceId, questionId, value);
    }
    get value() {
        return get(this.valueWritable);
    }
    set value(value) {
        this.valueWritable.set(value);
    }
    toJSON() {
        return {
            id: this.id,
            instanceId: this.instanceId,
            questionId: this.questionId,
            value: this.value,
        };
    }
}
